import { noop } from "lodash";
import { FunctionComponent, useCallback, useState } from "react";
import { Subject } from "rxjs";
import { useAppLoader } from "../../../../../components/loader/app-loader-hook";
import { UsersService } from "../../../../../store/users/service";
import { UsersSearchComponent } from "../../../all/search-wrapper";
import { DelegateUsersList } from "../../../all/views/delegates";

export const AddUserModal: FunctionComponent<{
  userReferenceId: string;
  existingDelegates: Array<string>;
  refresh: Subject<void>;
}> = ({ userReferenceId, existingDelegates, refresh }) => {
  const loader = useAppLoader();

  const [selectedDelegates, setSelectedDelegates] = useState<Array<string>>(
    existingDelegates
  );

  const onAddDelegateUser = useCallback(
    (userDelegateId: string) => {
      setSelectedDelegates((x) => [...x, userDelegateId]);
      loader(UsersService.addDelegateUser(userReferenceId, userDelegateId))
        .then(() => refresh.next())
        .catch(noop);
    },
    [userReferenceId]
  );

  return (
    <UsersSearchComponent>
      <DelegateUsersList
        onAddDelegate={onAddDelegateUser}
        existingDelegates={selectedDelegates}
      />
    </UsersSearchComponent>
  );
};
